import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../api/auth';
import { errorMessage } from '../../api/client';
import { Alert, Button, TextField } from '../../components/ui';

/** Step 1 of the reset: the API always answers 204, then the provider emails a link. */
export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const forgot = useMutation({
    mutationFn: async () => {
      const value = email.trim();
      await authApi.forgotPassword(value);
      navigate('/reset-password', {
        state: {
          email: value,
          notice:
            'If that account exists, a reset code is on its way to its verified email or phone.',
        },
      });
    },
  });

  return (
    <>
      <h1 className="auth__title">Forgot your password?</h1>
      <p className="auth__lead">
        Enter your email address and we will send a code to the verified contact on the account.
      </p>
      {forgot.error ? <Alert kind="error">{errorMessage(forgot.error)}</Alert> : null}
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
          forgot.mutate();
        }}
        noValidate
      >
        <TextField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" loading={forgot.isPending} disabled={!email.trim()}>
          Send reset code
        </Button>
      </form>
      <p className="auth__switch">
        Already have a code? <Link to="/reset-password">Reset your password</Link>
        <br />
        <Link to="/sign-in">Back to sign in</Link>
      </p>
    </>
  );
}
